import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { PowerbiService } from '../../../services/powerbi.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { SlicerDto } from '../../../dto/powerbi/slicer.dto';

@Component({
  selector: 'app-modal-download',
  templateUrl: './modal-download.component.html',
  styleUrl: './modal-download.component.scss',
})
export class ModalDownloadComponent implements OnInit {
  @ViewChild('modalDown')
  modalDown!: ElementRef;
  mensaje: string = '';
  enableBtn: boolean = false;
  private intervalId: any;

  @Input() currentKey: string = '';
  @Input() nameFile: string = '';
  @Input() isAuth: boolean = false;
  @Output() correoEmitter = new EventEmitter<any>();

  constructor(
    private pbiService: PowerbiService,
    private alertaModalService: AlertaModalService
  ) {}

  ngOnInit(): void {
    this.mensaje = 'Generando archivo de descarga, por favor espere...';
    this.intervalId = setInterval(() => {
      this.pbiService.downloadStatus(this.currentKey).subscribe(
        response => {
          if (response.status === 'success') {
            this.enableBtn = true;
            this.mensaje = 'El archivo está listo para descargar';
            this.detenerIntervalo();
          }
        },
        error => {
          this.alertaModalService.error('Error al descargar el archivo');
        }
      );
    }, 60000);
  }

  detenerIntervalo(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  ngOnDestroy(): void {
    this.detenerIntervalo();
  }

  descargar() {
    this.pbiService.downloadFile(this.currentKey).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = this.nameFile + '.xlsx';
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(anchor);
        if (response) {
          this.alertaModalService.exito(
            '¡Éxito!',
            'El archivo se ha descargado correctamente.'
          );
        }
        this.mensaje = 'Generando archivo de descarga, por favor espere...';
      },
      error => {
        this.alertaModalService.error('Error al descargar el archivo');
      }
    );
  }

  abrirCerrarModal() {
    this.modalDown.nativeElement.click();
  }
}
